import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalanceEmailTemplate.UploadAttachment.IRequest;
type Response = Api.Core.StatementBalanceEmailTemplate.UploadAttachment.IResponse;
type Headers = Api.Core.StatementBalanceEmailTemplate.UploadAttachment.IHeaders;
const apiStatementBalanceEmailTemplateUploadAttachmentPath =
  '/api/Management/StatementBalanceEmailTemplate/:id/UploadAttachment';
export default async function statementBalanceEmailTemplateUploadAttachmentApi(
  id: number,
  request: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiStatementBalanceEmailTemplateUploadAttachmentPath, { id }),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
